var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"m-con"},[_c('div',{staticClass:"m-head-bg"}),_c('div',{staticClass:"m-main u-container"},[_vm._m(0),_c('div',{staticClass:"m-main-text",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-main-title"},[_c('span',[_vm._v("公司简介")])])
}]

export { render, staticRenderFns }